var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7143 3.57143V10.7143H3.57143V3.57143H10.7143ZM0 0V14.2857H14.2857V0H0ZM28.5714 8.92857V16.0714H21.4286V8.92857H28.5714ZM17.8571 5.35714V19.6429H32.1429V5.35714H17.8571ZM10.7143 25V32.1429H3.57143V25H10.7143ZM0 21.4286V35.7143H14.2857V21.4286H0Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7137 14.2852V24.9994H24.9994V35.7137H14.2852V49.9994H49.9994V14.2852H35.7137ZM28.5709 28.5709H35.7137V35.7137H28.5709V28.5709ZM24.9994 46.428H17.8566V39.2852H24.9994V46.428ZM35.7137 46.428H28.5709V39.2852H35.7137V46.428ZM46.428 46.428H39.2852V39.2852H46.428V46.428ZM46.428 35.7137H39.2852V28.5709H46.428V35.7137ZM39.2852 24.9994V17.8566H46.428V24.9994H39.2852Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.1000584852aba4f72375cc5ab08443ae.svg";
export { ForwardRef as ReactComponent };